/**
 * Words for problem+json responses from our own endpoints. Screens map the
 * problem `type` here and never show `detail` raw. Field errors (`errors`) are
 * our own contract messages, so screens show those against their fields.
 */
export const PROBLEM_BASE = 'https://myhomeplus.co.za/problems';
export const TOO_MANY_REQUESTS_COPY = 'Too many attempts. Wait a minute, then try again.';
export const OFFLINE_COPY = 'We could not reach MyHome+. Check your connection and try again.';
export const FALLBACK_COPY = 'Something went wrong on our side. Try again in a moment.';
const PROBLEM_COPY = {
    'validation-error': 'Some details need fixing. Check the fields marked below.',
    'rate-limited': TOO_MANY_REQUESTS_COPY,
    unauthenticated: 'You have been signed out. Sign in again to carry on.',
    forbidden: 'Your account cannot do that.',
    'not-found': 'We could not find that. It may have been removed.',
};
/** The words for a failed call. Pass nothing when the request never arrived. */
export function problemMessage(problem) {
    if (problem === undefined)
        return OFFLINE_COPY;
    const slug = problem.type?.startsWith(`${PROBLEM_BASE}/`)
        ? problem.type.slice(PROBLEM_BASE.length + 1)
        : '';
    return PROBLEM_COPY[slug] ?? (problem.status === 429 ? TOO_MANY_REQUESTS_COPY : FALLBACK_COPY);
}
/** Narrows an unknown error body to a problem, or undefined. */
export function asProblem(value) {
    if (typeof value !== 'object' || value === null)
        return undefined;
    const record = value;
    if (typeof record.type !== 'string' && typeof record.status !== 'number')
        return undefined;
    return {
        type: typeof record.type === 'string' ? record.type : undefined,
        status: typeof record.status === 'number' ? record.status : undefined,
        errors: Array.isArray(record.errors)
            ? record.errors.filter((e) => typeof e === 'object' &&
                e !== null &&
                typeof e.path === 'string' &&
                typeof e.message === 'string')
            : undefined,
    };
}
//# sourceMappingURL=problems.js.map